import api from '@/utils/api';

/**
 * Get Quote Modules
 * @param {string} companyId - the companyId
 * @returns {Promise}
 */
const getQuoteModulesApi = (companyId) =>
  api.get(`/company/${companyId}/quote-module`);

export default getQuoteModulesApi;
